import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { logisticsApi } from "./apiClient";

export const knownFeatureFlagsSchema = z.enum(["CarePatientNote"]);

export const featureFlagSchema = z.object({
  name: knownFeatureFlagsSchema,
  isEnabled: z.boolean(),
});

const featureFlagKeys = {
  all: ["featureFlags"] as const,
  flag: (key: string) => ["featureFlag", key] as const,
};

async function getFeatureFlagStatus(key: string) {
  return (await logisticsApi.get(`/features/${key}`).json(featureFlagSchema))
    .isEnabled;
}

export const useFeatureFlag = (key: string) => {
  return useQuery({
    queryKey: featureFlagKeys.flag(key),
    queryFn: () => getFeatureFlagStatus(key),
  });
};
